import React, { useEffect, useState } from "react";
import "../style.css";
import {
  Subtitle2,
  Caption1,
  Caption1Strong,
} from "@fluentui/react-components";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../redux/store";
import FormContainerWithList from "../../../components/FormContainerWithList";
import { configFm } from "../../../types";
import apiServices from "../../../service";
import OverlayLoader from "../../../components/OverlayLoader";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import ContentLoader from "../../../components/Loader/ContentLoader";
type ComponentProps = {
  [x: string]: any;
  changeMode?: (mode: string) => void;
  setActiveItem?: (item: any) => void;
  closePage?: () => void;
};
const DependantForm = (props: ComponentProps) => {
  const [formContext, setFormContext] = useState("CLIENT_DEPENDANT");
  const [loading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState({});
  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const [configForm, setConfigForm] = useState<configFm>();
  const { clientId, action, caseId, selectedItemId } = useParams();
  useEffect(() => {
    if (
      formContext &&
      formSettingsObj?.data &&
      formSettingsObj?.data &&
      formSettingsObj.data.formConfig !== undefined
    ) {
      let configObj = formSettingsObj.data.formConfig.find(
        (item: any) => item.context === formContext
      );
      if (configObj) {
        setConfigForm(configObj);
      }
    }
  }, [formSettingsObj]);
  useEffect(() => {
    getDependantsList();
  }, [props.activeCustomerId]);

  const loadListData = () => {
    getDependantsList();
  };
  const getDependantsList = async () => {
    setLoading(true);
    try {
      const res = await apiServices.dependant.getList(clientId);

      if (res.data !== undefined) {
        if (res.data.data) {
          const singleData = {
            dependants: res.data.data,
          };
          setInitialData(singleData);
        }
        setLoading(false);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  return loading ? (
    <ContentLoader />
  ) : (
    <div className="form-container-wrapper">
      <FormContainerWithList
        context={formContext}
        config={configForm}
        activeCustomerId={clientId}
        notify={props.notify}
        initialData={initialData}
        reloadData={loadListData}
        section="dependant"
      />
    </div>
  );
};

export default DependantForm;
